import React from "react";
import {SxProps, Theme} from "@mui/material";
import Box from "@mui/material/Box";

import {designColors, designTokens} from "~/ui";

export interface BmOverlineLabelProps {
  className?: string;
  sx?: SxProps<Theme>;
  component?: React.ElementType;
  children: React.ReactNode;
}

export const BmOverlineLabel: React.FC<BmOverlineLabelProps> = ({className, sx, component = "span", children}) => {
  return (
    <Box
      component={component}
      className={className}
      sx={{
        display: "block",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        fontSize: designTokens.fontSize.xs,
        fontWeight: designTokens.fontWeight.medium,
        lineHeight: designTokens.lineHeight.tight,
        color: designColors.grey_5,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
